module.exports = __webpack_public_path__ + "img/discoveryDetailDeleivery.c7100d21.png";